// Prefer to use `import type {} from '@mui/lab/themeAugmentation';` instead to avoid importing an empty file.